/**
 * orga-app-api - veranstaltungstypen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungsTypRolleRequest { 
    rolle_id: string;
    veranstaltungstyp_id: string;
}

